<template>
    <div style="margin-top: 10px; margin-left: 30px;">
        <el-card shadow="hover" class="document-card">

            <el-row :gutter="20">
                <el-col :span="7">
                    <el-button type="primary">
                        合规评估列表
                    </el-button>
                </el-col>

            </el-row>

            <el-row :gutter="20" type="flex" justify="end" style="margin-bottom: 20px;">
                <el-col :span="12">
                    <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
                        <el-select v-model="authState" placeholder="认证状态" style="width: 125px;"
                            @change="handleFilterChange">
                            <el-option label="全部" value="全部"></el-option>
                            <el-option label="待审核" value="审核中"></el-option>
                            <el-option label="审核通过" value="审核通过"></el-option>
                            <el-option label="审核驳回" value="审核驳回"></el-option>

                        </el-select>
                        <el-input v-model="assetName" placeholder="请输入资产名称..." style="width: 350px;"
                            @keydown.enter.native="doSearch" class="search-input" clearable>
                            <el-button slot="append" icon="el-icon-search" @click="doSearch"
                                style="background-color: #1E88E5; color: white;">搜索</el-button>
                        </el-input>
                    </div>
                </el-col>
            </el-row>


            <component v-bind:is="currentName" @changeName="changeName"></component>
            <div class="table" v-if="currentName === ''" style="margin-top: 20px; width: 100%">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f5f5f5' }">
                    <el-table-column type="index" label="序号" width="80" fixed="left" align="center">
                    </el-table-column>

                    <el-table-column prop="registrationId" label="资产登记编号" min-width="200" align="center">
                    </el-table-column>

                    <el-table-column prop="assetName" label="资产登记名称" min-width="300" align="center">
                    </el-table-column>

                    <el-table-column prop="dataSource" label="数据来源" min-width="100" align="center">
                    </el-table-column>

                    <el-table-column prop="industry" label="所属行业" min-width="269" align="center">
                    </el-table-column>

                    <el-table-column prop="state" label="审核状态" min-width="100" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state === '审核中'">待审核</span>
                            <span v-else>{{ scope.row.state }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="complianceReport" label="合规报告" min-width="210" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.complianceReport" type="primary" @click="downloadFile(scope.row)">
                                {{ scope.row.complianceReport }}
                            </el-link>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" min-width="150" align="center">
                        <template slot-scope="scope">

                            <el-button v-if="scope.row.state === '审核驳回' || scope.row.state === '审核通过'" size="mini"
                                type="primary" @click="handleView(scope.row)" style="
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                查看详情
                            </el-button>
                            <!-- ="scope.row.state === '待审核' || scope.row.state === '审核中'" -->
                            <el-button v-if="scope.row.state === '待审核' || scope.row.state === '审核中'" size="mini"
                                type="success" @click="handleComliance(scope.row)" style="
                                    background-color: #67C23A;
                                    border-color: #67C23A;
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                去审核
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <div v-if="currentName === ''" class="block" style="display: flex; justify-content: center; margin-top: 20px">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="boardsTotal"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"
                :background="true">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../../components/AddBoardContent";

export default {
    name: "DataComplianceShowListManager",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            pageSize: 10,
            assetName: '',
            currentName: '',
            tableData: [],
            authState: '全部'
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        // 格式化日期时间
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData();
        },
        initTableData() {

            let user = JSON.parse(window.localStorage.getItem('user'));


            this.getRequest('/web/dataCompliance/queryList?assetName=' + this.assetName + '&state=' + this.authState + '&currPage=' + this.currPage + '&pageSize=' + this.pageSize).then(resp => {
                console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });


        },
        // 下载文件
        async downloadFile(row) {
            console.log(row);
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataComplianceDetail/download?registrationId=' + row.registrationId + '&fileName=' + row.complianceReport,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', row.complianceReport);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },
        doSearch() {
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, assetName: this.assetName }
            });
            this.initTableData(this.assetName);
        },
        changeName(name) {
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },


        handleView(row) {
            this.$router.push({
                path: '/DataComplianceDetailManager',
                query: { registrationId: row.registrationId }
            });
        },
        handleComliance(row) {
            this.$router.push({
                path: '/ComplianceManager',
                query: { registrationId: row.registrationId, userId: JSON.parse(window.localStorage.getItem('user')).id }
            });
        },

        handleFilterChange(value) {
            this.authState = value;
            this.initTableData(); // 筛选条件变化时重新加载数据
        },
    }
}
</script>

<style scoped>
/* 按钮统一样式 */
.el-button--mini {
    min-width: 60px;
    height: 28px;
    line-height: 1;
}

/* 编辑按钮效果 */
.el-button--success {
    background-color: #67C23A;
    border-color: #67C23A;
}

.el-button--success:hover {
    background-color: #85ce61 !important;
    border-color: #85ce61 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(103, 194, 58, 0.3);
}

.el-button--success:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 删除按钮效果 */
.el-button--danger {
    background-color: #F56C6C;
    border-color: #F56C6C;
}

.el-button--danger:hover {
    background-color: #f78989 !important;
    border-color: #f78989 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(245, 108, 108, 0.3);
}

.el-button--danger:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 分页组件优化 */
.el-pagination.is-background {
    padding: 15px 0;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409EFF;
    color: #fff;
    font-weight: bold;
}

.el-pagination.is-background .el-pager li:hover {
    color: #409EFF;
}

.el-pagination__jump {
    margin-left: 10px;
}



/* 表头样式 */
.document-card>>>.el-table__header th {
    text-align: center;
    font-size: 14px;
    color: rgb(46, 44, 44);
}

/* 状态列可点击样式 */
.document-card>>>.el-table__body .el-table__cell span[style*="color"] {
    cursor: pointer;
    /*  下划线 */
    text-decoration: underline;
}
</style>
